<template>
  <div>
    <pay-title :order-info="orderInfo"></pay-title>
    <h1>请输入6位验证码</h1>
    <div class="mobile-mask">
      验证码将发送至 <span>{{ userInfo.mobileMask }}</span>
    </div>
    <label class="input-wrapper" for="password">
      <input
        v-model="codes"
        @input="onCodesInput"
        class="input"
        id="password"
        type="tel"
        maxlength="6"
      />
      <div class="password-input-wrapper">
        <div
          v-for="(item, index) in displayCodes"
          class="password-input"
          :key="index"
        >
          {{ item }}
          <div v-if="index === codes.length" class="password-cursor"></div>
        </div>
      </div>
    </label>
    <div
      class="get-code"
      :class="{ 'get-code--disable': disableSeedCodeBtn }"
      @click="sendSmsCode"
    >
      <div class="code-text">{{ sendCodeBtnText }}</div>
    </div>
    <div>
      <button class="button-confirm" @click="confirmPay">确认付款</button>
    </div>
  </div>
</template>

<script>
import PayTitle from '@/components/CashierDesk/PayTitle'
import dayjs from 'dayjs'
import { sendVCurrencyPaySms } from '@/api/order'

const START_TIME_KEY = 'caiBiPayCodeStartTime'

export default {
  name: 'PayCaiBi',
  components: { PayTitle },
  props: ['orderInfo', 'orderId'],
  data() {
    return {
      codes: '',
      sendCodeBtnText: '点击发送验证码',
      disableSeedCodeBtn: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo
    },
    displayCodes() {
      let _codes = this.codes.split('')
      _codes = _codes.concat(new Array(6 - _codes.length).fill(''))

      return _codes
    }
  },
  created() {
    this.$store.dispatch('user/getUserInfo', false)
    // this.sendSmsCode(true)

    this.checkCountDown()
  },
  methods: {
    onCodesInput(e) {
      this.codes = e.target.value.replace(/\D/g, '')
    },
    checkCountDown() {
      const localStartTime = sessionStorage.getItem(START_TIME_KEY)
      if (localStartTime) {
        const localCountDown = this.getCountDownSecond(localStartTime)
        if (localCountDown >= 0) {
          this.startCountDown(localStartTime)
        }
      }
    },
    async sendSmsCode() {
      const { result } = await sendVCurrencyPaySms(this.orderId)

      if (result.code === 0) {
        this.startCountDown()
      } else {
        this.$toasted.show(result.msg || '发送失败，请重试', {
          position: 'bottom-center',
          duration: 3000
        })
      }
    },
    getCountDownSecond(startTime) {
      const currentTime = dayjs()
      return 60 - currentTime.diff(startTime, 'second')
    },
    startCountDown(startTime) {
      startTime = startTime || dayjs()

      this.disableSeedCodeBtn = true

      sessionStorage.setItem(START_TIME_KEY, startTime.toString())

      const setCountDown = () => {
        const countDown = this.getCountDownSecond(startTime)
        if (countDown > 0) {
          this.sendCodeBtnText = countDown + 's 后重发'
          this.timeOut = setTimeout(setCountDown, 500)
        } else {
          sessionStorage.removeItem(START_TIME_KEY)
          this.disableSeedCodeBtn = false
          this.sendCodeBtnText = '重新发送'
        }
      }

      setCountDown()
    },
    confirmPay() {
      if (this.codes.length < 6) {
        this.$toasted.show('请输入6位验证码', {
          position: 'bottom-center',
          duration: 3000
        })
        return
      }

      this.$emit('pay', this.codes)
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin: 0 0 20px;
  font-size: 20px;
  color: #262626;
}

.mobile-mask {
  font-size: 16px;
  color: #858585;

  span {
    color: #262626;
  }
}

.input-wrapper {
  position: relative;
}

.password-input {
  position: relative;
  width: 40px;
  margin-right: 5px;
  border-bottom: 1px solid #ebebeb;
  background-color: transparent;
  text-align: center;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  cursor: auto;
}

.password-cursor {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 1px;
  height: 70%;
  background-color: #323233;
  transform: translate(-50%, -50%);
  display: none;
  animation: 1s cursor-flicker infinite;
}

.password-input-wrapper {
  display: flex;
  padding: 30px 0 0;
}

.input:focus + .password-input-wrapper {
  .password-cursor {
    display: block;
  }
}

@keyframes cursor-flicker {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.input {
  position: absolute;
  left: -10000px;
  color: transparent;
}

.get-code {
  padding-top: 30px;
  font-size: 14px;
  color: #046bcc;
  text-align: center;

  .code-text {
    margin: 0 auto;
    cursor: pointer;
  }
}

.button-confirm {
  width: 320px;
  height: 46px;
  margin: 30px auto;
  background-color: #046bcc;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  line-height: 46px;
  color: #ffffff;
  transition: opacity 0.3s;

  &:active {
    outline: none;
    border: none;
    opacity: 0.5;
  }

  &:focus {
    outline: none;
    border: none;
  }
}
</style>
